



































import { Banner, Promoted, Result } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters, mapState, Store } from 'vuex';
import { EVENTS } from '../../bus/events.const';
import { Messages } from '../../i18n';
import { EmpathyXConfig, RecommendationsParentModuleKey, ResultComponentsConfig } from '../../models';
import { GETTERS_KEYS, RootStoreState, SUBMODULES_PATHS } from '../../store';
import { isArrayEmptyOrNull } from '../../utils';

@Component({
  computed: {
    ...mapGetters({
      components: GETTERS_KEYS.config.components,
      config: GETTERS_KEYS.config.config,
      resultConfig: GETTERS_KEYS.config.recommendationsResultConfig
    }),
    ...mapState(SUBMODULES_PATHS.search, ['banners', 'promoteds'])
  }
})
export default class Recommendations extends Vue {
  config: EmpathyXConfig;
  resultConfig: ResultComponentsConfig;
  banners: Banner[];
  promoteds: Promoted[];
  $store: Store<RootStoreState>;

  @Prop({ required: true })
  type: RecommendationsParentModuleKey;

  get recommendations(): Result[] {
    return this.$store.state[this.type].recommendations.recommendations;
  }

  get recommendationsPage(): number {
    return this.$store.state[this.type].recommendations.page;
  }

  get infiniteScrollEnabled(): boolean {
    return this.$store.getters[GETTERS_KEYS[this.type].infiniteScrollEnabled];
  }

  get messages(): Messages['recommendations'] {
    return this.$x.messages[this.type]?.recommendations ?? this.$x.messages.recommendations;
  }

  get showAllButton(): boolean {
    return this.recommendationsPage === 1 && !this.infiniteScrollEnabled;
  }

  get renderRecommendations(): boolean {
    return !isArrayEmptyOrNull(this.recommendations) || !isArrayEmptyOrNull(this.banners) || !isArrayEmptyOrNull(this.promoteds);
  }

  get showAllEvent(): string {
    return this.type === RecommendationsParentModuleKey.emptySearch
      ? EVENTS.RecommendationsEmptySearchShowAll
      : EVENTS.RecommendationsNoResultsShowAll;
  }
}
